/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewladderstep2detail4Inputs */

const en_letterpreviewladderstep2detail4 = /** @type {(inputs: Letterpreviewladderstep2detail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triggers legal deadline; required to terminate`)
};

const pt_letterpreviewladderstep2detail4 = /** @type {(inputs: Letterpreviewladderstep2detail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com prazo legal; necessária para rescindir`)
};

/**
* | output |
* | --- |
* | "Triggers legal deadline; required to terminate" |
*
* @param {Letterpreviewladderstep2detail4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewladderstep2detail4 = /** @type {((inputs?: Letterpreviewladderstep2detail4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewladderstep2detail4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewladderstep2detail4(inputs)
	return pt_letterpreviewladderstep2detail4(inputs)
});
export { letterpreviewladderstep2detail4 as "letterPreviewLadderStep2Detail" }